import styled from 'styled-components';

export const Question = styled.span`
  position: relative;
  width: 26px;
  min-width: 26px;
  height: 26px;
  min-height: 26px;
  border: solid 1px #3f3f3f;
  border-radius: 50%;
  background: #ffffff;
  color: #3f3f3f;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 16px;
  font-weight: 600;

  cursor: pointer;

  ::after {
    content: '?';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
